// extracted by mini-css-extract-plugin
export default {"main":"Home_main__1U5We","btnprimary":"Home_btnprimary__YmaBQ","link":"Home_link__qkwRe"};